import { config } from "./elrond";

export const SNAKE_VESTING_SC_ADDRESS = config.contracts['snake-vesting'].address;
